
import { defineComponent, ref, onMounted,computed,reactive } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: 'Form',
        },
        data: {
            type: Object,
        },
        id: {
            type: String,
            required: true
        },
    },
    setup (props) {
        const form = reactive({
            id: '',
            ibps_status_id: '',
            payment_portal_status_id: '',
            payment_status_event_id: '',
            check_status_id: '',
            payment_method_id: '',
            sms_template_id: '',
            email_template_id: '',
            sms_notification_for_vendor: false as any,
            sms_notification_for_employee: false as any,
            email_notification_for_vendor: false as any,
            email_notification_for_employee: false as any,
            sms_group_recipients: [] as any,
            email_group_recipients: [] as any
        })
        const selectedItems = ref([])
        const sms_for_vendor = ref(false);
        const sms_for_employee = ref(false);
        const email_for_vendor = ref(false);
        const email_for_employee = ref(false);
        const name = ref('Payment Status Mapping')
        const router = useRouter()
        const store = useStore()

        const handleSaving =() => {
            !props.id ? storeRecord() : updateRecord()
        }

        const storeRecord = () => {
            store.dispatch('PaymentStatusMapping/store', form)
        }

        const updateRecord = () => {
            store.dispatch('PaymentStatusMapping/update', form)
        }

        const filterOption = (
            input: string,
            option: { children: { children: string }[] }
            ) => {
            return (
                option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            );
        };

        const onChangeSmsNotificationforVendor = (e: any) => {
            sms_for_vendor.value = e.target.checked;
            form.sms_notification_for_vendor = sms_for_vendor.value == false ? false : true;
        };

        const onChangeSmsNotificationforEmployee = (e: any) => {
            sms_for_employee.value = e.target.checked;
            form.sms_notification_for_employee = sms_for_employee.value == false ? false : true;
        };

        const onChangeEmailNotificationforVendor = (e: any) => {
            email_for_vendor.value = e.target.checked;
            form.email_notification_for_vendor = email_for_vendor.value == false ? false : true;
        };

        const onChangeEmailNotificationforEmployee = (e: any) => {
            email_for_employee.value = e.target.checked;
            form.email_notification_for_employee = email_for_employee.value == false ? false : true;
        };

        const back = () => {
            router.go(-1)
        }

        onMounted(() => {
            store.dispatch('Option/getAllIbpsStatus')
            store.dispatch('Option/getAllPaymentPortalStatus')
            store.dispatch('Option/getAllPaymentStatusEvent')
            store.dispatch('Option/getAllCheckStatuses')
            store.dispatch('Option/getAllPaymentMode')
            store.dispatch('Option/getAllSmsTemplate')
            store.dispatch('Option/getAllEmailTemplate')
            store.dispatch('Option/getAllGroupSms')
            store.dispatch('Option/getAllGroupEmail')



            if(props.id){
                var sms_list: any[] = []
                var email_list: any[] = []
                store.dispatch('PaymentStatusMapping/show',props.id).then((res:any) => {
                    form.id = res.data.id,
                    form.ibps_status_id = res.data.ibps_status_id,
                    form.payment_portal_status_id = res.data.payment_portal_status_id,
                    form.payment_status_event_id = res.data.payment_status_event_id,
                    form.check_status_id = res.data.check_status_id,
                    form.payment_method_id = res.data.payment_method_id,
                    form.sms_template_id = res.data.sms_template_id,
                    form.email_template_id = res.data.email_template_id,
                    res.data.sms_group_recipients.forEach((item: any) => {
                        sms_list.push(item.notification_group_id)
                    })
                    res.data.email_group_recipients.forEach((item: any) => {
                        email_list.push(item.notification_group_id)
                    })
                    form.sms_group_recipients = sms_list
                    form.email_group_recipients = email_list
                    form.sms_notification_for_vendor = res.data.sms_notification_for_vendor
                    form.sms_notification_for_employee = res.data.sms_notification_for_employee
                    form.email_notification_for_vendor = res.data.email_notification_for_vendor
                    form.email_notification_for_employee = res.data.email_notification_for_employee
                    sms_for_vendor.value = res.data.sms_notification_for_vendor == true ? true : false
                    sms_for_employee.value = res.data.sms_notification_for_employee == true ? true : false
                    email_for_vendor.value = res.data.email_notification_for_vendor == true ? true : false
                    email_for_employee.value = res.data.email_notification_for_employee == true ? true : false
                })
            }
        })

        const ibps_statuses = computed(() => store.getters['Option/all_ibps_status'])
        const payment_portal_statuses = computed(() => store.getters['Option/all_payment_portal_status'])
        const payment_status_events = computed(() => store.getters['Option/all_payment_status_event'])
        const check_statuses = computed(() => store.getters['Option/all_check_statuses'])
        const payment_mode = computed(() => store.getters['Option/all_payment_mode'])
        const sms_templates = computed(() => store.getters['Option/all_sms_templates'])
        const email_templates = computed(() => store.getters['Option/all_email_templates'])
        const sms_groups = computed(() => store.getters['Option/all_group_sms'])
        const email_groups = computed(() => store.getters['Option/all_group_email'])
        

        return {
            form,
            name,
            ibps_statuses,
            payment_portal_statuses,
            payment_status_events,
            check_statuses,
            payment_mode,
            sms_templates,
            email_templates,
            selectedItems,
            sms_groups,
            email_groups,
            sms_for_vendor,
            sms_for_employee,
            email_for_vendor,
            email_for_employee,
            filterOption,
            handleSaving,
            onChangeSmsNotificationforVendor,
            onChangeSmsNotificationforEmployee,
            onChangeEmailNotificationforVendor,
            onChangeEmailNotificationforEmployee,
            back
        }
    },
})
